import { Paper, Tab, Tabs, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { GeneralSettingsTab } from '../../interfaces/Settings/SettingsTab';
import { sharedStyles } from '../../utils/Style';
import { availableGeneralSettingsTabs } from '../../variables/GeneralSettings';

export const DummyScrollButton = () => <></>;

interface GeneralSettingsTabsProps {
  selectedTab: GeneralSettingsTab;
}

export const GeneralSettingsTabs = (props: GeneralSettingsTabsProps) => {
  const navigate = useNavigate();

  const handleChange = useCallback(
    (_: any, i: number) =>
      navigate(
        `/settings/general-settings/${availableGeneralSettingsTabs[i].path}`,
      ),
    [],
  );

  return (
    <Paper>
      <Tabs
        variant='scrollable'
        value={availableGeneralSettingsTabs.findIndex(
          (tab) => tab.kind === props.selectedTab,
        )}
        onChange={handleChange}
        ScrollButtonComponent={DummyScrollButton}
      >
        {availableGeneralSettingsTabs.map((tab) => (
          <Tab
            key={tab.kind}
            label={
              <Typography sx={sharedStyles.tabLabel}>{tab.name}</Typography>
            }
          />
        ))}
      </Tabs>
    </Paper>
  );
};
